import _createForOfIteratorHelper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { __awaiter, __rest } from "tslib";
import AuthService from '@finam/txservices-auth/AuthService';
import AuthClientService from '@finam/txservices-auth/client/AuthClientService';
import { ConfirmationType } from '@finam/txservices-auth/types';
import { SessionContextKey } from '@finam/txservices-auth/proto';
import { AuthByQRSessionResponse_Status } from '@finam/txservices-auth/client/proto';
import EdoxAccessService from '@finam/txservices-edox/access/EdoxAccessService';
import { CheckAccountRegistrationRequest, RegisterAccountRequest, ConfirmRegistrationRequest } from '@finam/txservices-edox/access/proto';
import { getIframeSource } from './mountIframe';
import oAuthPopup from './utils/OAuthPopup';
import buildPersonalData from './utils/buildPersonalData';
import { createServiceError } from './utils/serverErrorFormatter';
import hashWith from './utils/hashWith';
import { phoneToLogin } from './utils/phone';
import BrowserTabsWatcher from './BrowserTabsWatcher';
export var EDOX_CONFIRMATION = {
  enable: true,
  codeLength: 6,
  timeout: 5 * 60 * 1000,
  type: ConfirmationType.SMS
};

var AuthProcessor = /*#__PURE__*/function () {
  function AuthProcessor(sevicesHosts, _a) {
    var _this = this;

    _classCallCheck(this, AuthProcessor);

    var env = _a.env,
        variant = _a.variant,
        appName = _a.appName,
        appVersion = _a.appVersion,
        providers = _a.providers,
        hasTokensForExchange = _a.hasTokensForExchange,
        getToken = _a.getToken,
        onChangeToken = _a.onChangeToken,
        onChangeNotCurrentToken = _a.onChangeNotCurrentToken,
        onLoginError = _a.onLoginError,
        onRegistrationSuccess = _a.onRegistrationSuccess,
        onRegistrationWatch = _a.onRegistrationWatch,
        onRegistrationError = _a.onRegistrationError,
        setNotYourComputer = _a.setNotYourComputer,
        authConfig = __rest(_a, ["env", "variant", "appName", "appVersion", "providers", "hasTokensForExchange", "getToken", "onChangeToken", "onChangeNotCurrentToken", "onLoginError", "onRegistrationSuccess", "onRegistrationWatch", "onRegistrationError", "setNotYourComputer"]);

    this.authorizeWithToken = function (token, receiveTime, provider) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, providerId;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.authService.authorizeWithToken(token, receiveTime);

              case 2:
                res = _context.sent;
                providerId = provider || res.provider;
                _context.next = 6;
                return this.handleChangeToken(res, providerId);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    this.exchangeOneTimeToken = function (token, provider) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _b, providerId, res;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                providerId = provider || ((_b = this.providers.find(function (p) {
                  return p.default;
                })) === null || _b === void 0 ? void 0 : _b.id) || (this.providers.length === 1 ? this.providers[0].id : undefined);
                _context2.next = 3;
                return this.authService.exchangeOneTimeToken(token, providerId);

              case 3:
                res = _context2.sent;
                _context2.next = 6;
                return this.handleChangeToken(res, providerId || res.provider);

              case 6:
                return _context2.abrupt("return", res);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    this.oneTimeToken = function (provider) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _yield$this$authServi, oneTimeToken;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.authService.oneTimeToken(provider);

              case 2:
                _yield$this$authServi = _context3.sent;
                oneTimeToken = _yield$this$authServi.oneTimeToken;
                return _context3.abrupt("return", oneTimeToken);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };

    this.exchangeToken = function (fromProvider, toProvider, token, receiveTime) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var ott;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.exchangeTokenFromProvider = fromProvider;
                _context4.prev = 1;
                _context4.next = 4;
                return this.authService.authorizeWithToken(token, receiveTime);

              case 4:
                _context4.next = 6;
                return this.oneTimeToken(toProvider);

              case 6:
                ott = _context4.sent;

              case 7:
                _context4.prev = 7;
                this.exchangeTokenFromProvider = undefined;
                return _context4.finish(7);

              case 10:
                _context4.next = 12;
                return this.exchangeOneTimeToken(ott, toProvider);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1,, 7, 10]]);
      }));
    };

    this.resend = function () {
      return _this.authService.confirmAuthorize('resend');
    };

    this.checkRegistration = function (data) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _c, _d, req, res;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                if (this.edoxAccessService) {
                  _context5.next = 3;
                  break;
                }

                throw new Error('Registration is not available');

              case 3:
                req = CheckAccountRegistrationRequest.create({
                  email: data.email,
                  phone: data.phone
                });
                _context5.next = 6;
                return this.edoxAccessService.checkAccountRegistration(req);

              case 6:
                res = _context5.sent;
                return _context5.abrupt("return", ((_d = (_c = res.userAccountInfo) === null || _c === void 0 ? void 0 : _c.userAccounts[0]) === null || _d === void 0 ? void 0 : _d.login) || phoneToLogin(req.phone));

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);
                this.onRegistrationError && this.onRegistrationError(createServiceError(_context5.t0));
                throw _context5.t0;

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 10]]);
      }));
    };

    this.register = function (data) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _e, req, res;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                if (this.edoxAccessService) {
                  _context6.next = 3;
                  break;
                }

                throw new Error('Registration is not available');

              case 3:
                req = RegisterAccountRequest.create({
                  email: data.email,
                  phone: data.phone,
                  password: data.password,
                  personalData: buildPersonalData(data)
                });
                _context6.next = 6;
                return this.edoxAccessService.registerAccount(req);

              case 6:
                res = _context6.sent;
                return _context6.abrupt("return", {
                  confirmation: Object.assign(Object.assign({}, EDOX_CONFIRMATION), {
                    addresses: [req.phone]
                  }),
                  authId: (_e = res.account) === null || _e === void 0 ? void 0 : _e.authenticationId
                });

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](0);
                this.onRegistrationError && this.onRegistrationError(createServiceError(_context6.t0));
                throw _context6.t0;

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 10]]);
      }));
    };

    this.registrationConfirm = function (authId, code) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var request;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                if (this.edoxAccessService) {
                  _context7.next = 3;
                  break;
                }

                throw new Error('Registration is not available');

              case 3:
                request = ConfirmRegistrationRequest.create({
                  authId: authId,
                  code: code
                });
                _context7.next = 6;
                return this.edoxAccessService.confirmRegistration(request);

              case 6:
                _context7.next = 12;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);
                this.onRegistrationError && this.onRegistrationError(createServiceError(_context7.t0));
                throw _context7.t0;

              case 12:
                this.onRegistrationSuccess && this.onRegistrationSuccess();

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 8]]);
      }));
    };

    this.requestRegistrationConfirmation = function (authId) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var res;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.edoxAccessService) {
                  _context8.next = 2;
                  break;
                }

                throw new Error('Registration is not available');

              case 2:
                if (authId) {
                  _context8.next = 4;
                  break;
                }

                throw new Error('Registration error: authId is empty');

              case 4:
                _context8.next = 6;
                return this.edoxAccessService.requestRegistrationConfirmation(authId);

              case 6:
                res = _context8.sent;
                return _context8.abrupt("return", Object.assign(Object.assign({}, EDOX_CONFIRMATION), {
                  codeLength: res.codeLength,
                  addresses: [res.maskedPhone]
                }));

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    };

    this.registrationWatch = function (registration) {
      _this.onRegistrationWatch && _this.onRegistrationWatch(registration);
    };

    this.getQRCode = function (provider, size) {
      return _this.authClientService.getQRCode(provider, size);
    };

    this.authByQRSession = function (qrSessionId) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var res, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.authClientService.authByQRSession(qrSessionId);

              case 2:
                res = _context9.sent;

                if (!(res.status === AuthByQRSessionResponse_Status.READY)) {
                  _context9.next = 10;
                  break;
                }

                _context9.next = 6;
                return this.getTokenProvider().setToken(res.jwtToken);

              case 6:
                response = this.getTokenProvider().buildResponse();
                _context9.next = 9;
                return this.handleChangeToken(response, response.provider);

              case 9:
                return _context9.abrupt("return", {
                  status: res.status,
                  confirmation: response.confirmation
                });

              case 10:
                return _context9.abrupt("return", {
                  status: res.status
                });

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    };

    this.getProviders = function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.getAuthProviders();

              case 2:
                return _context10.abrupt("return", this.authProviders.map(function (p) {
                  return p.name;
                }));

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    };

    this.getAuthProviders = function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(this.authProviders === undefined)) {
                  _context11.next = 4;
                  break;
                }

                _context11.next = 3;
                return this.authService.getAuthProviders();

              case 3:
                this.authProviders = _context11.sent;

              case 4:
                return _context11.abrupt("return", this.authProviders);

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    };

    this.isLoggedIn = function () {
      return _this.authService.isLoggedIn();
    };

    this.getTokenProvider = function () {
      return _this.authService.getTokenProvider();
    };

    this.forceRenew = function () {
      return _this.authService.forceRenew();
    };

    this.logout = function () {
      return _this.authService.logout();
    };

    this.dispose = function () {
      _this.browserTabsWatcher.disconnect();

      _this.handleAway();
    };

    this.handleChangeToken = function (res, newProvider) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _f, authSourceRaw, provider;

        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!this.exchangeTokenFromProvider) {
                  _context12.next = 3;
                  break;
                }

                this.onChangeNotCurrentToken(res, this.exchangeTokenFromProvider);
                return _context12.abrupt("return");

              case 3:
                authSourceRaw = res.sessionContext.context[SessionContextKey.CONTEXT_AUTH_SOURCE];
                this.browserTabsWatcher.listen({
                  personId: (_f = res.session.person) === null || _f === void 0 ? void 0 : _f.id,
                  authSource: authSourceRaw ? parseInt(authSourceRaw, 10) : undefined
                });

                if (!newProvider) {
                  _context12.next = 15;
                  break;
                }

                provider = this.providers.find(function (p) {
                  return p.id === newProvider;
                });

                if (provider) {
                  _context12.next = 11;
                  break;
                }

                this.authService.getTokenProvider().removeToken();
                this.authService.stopRenew();
                throw new Error('provider is not defined');

              case 11:
                _context12.next = 13;
                return this.onChangeToken(res, provider);

              case 13:
                _context12.next = 17;
                break;

              case 15:
                _context12.next = 17;
                return this.onChangeToken(res);

              case 17:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    };

    this.handleAway = function () {
      if (_this.authService.isLoggedIn()) {
        _this.authService.stopRenew();
      }
    };

    this.handleActive = function () {
      if (_this.authService.isLoggedIn()) {
        _this.authService.resumeRenew();
      }
    };

    this.env = env;
    this.variant = variant;
    this.appName = appName;
    this.appVersion = appVersion;
    this.providers = providers;
    this.hasTokensForExchange = hasTokensForExchange;
    this.getToken = getToken;
    this.onChangeToken = onChangeToken;
    this.onChangeNotCurrentToken = onChangeNotCurrentToken;
    this.onLoginError = onLoginError;
    this.onRegistrationSuccess = onRegistrationSuccess;
    this.onRegistrationWatch = onRegistrationWatch;
    this.onRegistrationError = onRegistrationError;
    this.setNotYourComputer = setNotYourComputer;
    var txauth = sevicesHosts.txauth,
        edox = sevicesHosts.edox;
    this.authService = new AuthService(txauth, Object.assign(Object.assign({}, authConfig), {
      onRenew: this.handleChangeToken,
      appName: this.appName,
      appVersion: this.appVersion,
      widgetVersion: "6.0.1"
    }));
    this.authClientService = new AuthClientService(txauth, this.authService.getTokenProvider());

    if (edox) {
      this.edoxAccessService = new EdoxAccessService(edox);
    }

    this.browserTabsWatcher = new BrowserTabsWatcher({
      env: env,
      variant: variant,
      appName: appName,
      isLoggedIn: function isLoggedIn() {
        return _this.authService.isLoggedIn();
      },
      onAway: this.handleAway,
      onActive: this.handleActive
    });
  }

  _createClass(AuthProcessor, [{
    key: "registrationAvailable",
    get: function get() {
      return !!this.edoxAccessService && this.variant === 'finam';
    }
  }, {
    key: "tryAuthorizeByProvider",
    value: function tryAuthorizeByProvider(providerId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var token;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                token = providerId && this.getToken(this.appName, providerId);

                if (!token) {
                  _context13.next = 6;
                  break;
                }

                _context13.next = 4;
                return this.authorizeWithToken(token.token, token.receiveTime, providerId);

              case 4:
                _context13.next = 8;
                break;

              case 6:
                _context13.next = 8;
                return this.tryAuthorizeWithExchangeToken({
                  toProvider: providerId
                });

              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "tryAuthorizeWithExchangeToken",
    value: function tryAuthorizeWithExchangeToken(_ref) {
      var fromAppName = _ref.fromAppName,
          toProvider = _ref.toProvider;

      var _a, _b;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this2 = this;

        var allProviders, lastAppName, allProvidersWithToken, exchangeVariants, _iterator, _step, _loop, exchangeVariant;

        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (this.hasTokensForExchange()) {
                  _context14.next = 2;
                  break;
                }

                return _context14.abrupt("return");

              case 2:
                _context14.next = 4;
                return this.getAuthProviders();

              case 4:
                allProviders = _context14.sent;
                lastAppName = fromAppName || this.appName;
                allProvidersWithToken = allProviders.filter(function (p) {
                  return !!_this2.getToken(lastAppName, p.name);
                });
                exchangeVariants = []; // eslint-disable-next-line no-restricted-syntax

                _iterator = _createForOfIteratorHelper(this.providers);

                try {
                  _loop = function _loop() {
                    var provider = _step.value;

                    if (!toProvider || provider.id === toProvider) {
                      var source = (_a = allProviders.find(function (p) {
                        return p.name === provider.id;
                      })) === null || _a === void 0 ? void 0 : _a.source;
                      var providerWithToken = source && ((_b = allProvidersWithToken.find(function (p) {
                        var _a;

                        return ((_a = p.source) === null || _a === void 0 ? void 0 : _a.source) === source.source;
                      })) === null || _b === void 0 ? void 0 : _b.name);

                      if (providerWithToken) {
                        var token = _this2.getToken(lastAppName, providerWithToken);

                        exchangeVariants.push({
                          fromProvider: providerWithToken,
                          toProvider: provider.id,
                          token: token.token,
                          receiveTime: token.receiveTime
                        });
                      }
                    }
                  };

                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                if (!(exchangeVariants.length === 1)) {
                  _context14.next = 14;
                  break;
                }

                exchangeVariant = exchangeVariants[0];
                _context14.next = 14;
                return this.exchangeToken(exchangeVariant.fromProvider, exchangeVariant.toProvider, exchangeVariant.token, exchangeVariant.receiveTime);

              case 14:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "authorize",
    value: function authorize(req) {
      var _a, _b;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var response, actualRequest, authProvider;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                actualRequest = {
                  login: req.login,
                  password: req.password,
                  provider: req.provider
                };
                req.notYourComputer !== undefined && ((_a = this.setNotYourComputer) === null || _a === void 0 ? void 0 : _a.call(this, req.notYourComputer));

                if (!(!req.noHash || this.setNotYourComputer && req.notYourComputer)) {
                  _context15.next = 8;
                  break;
                }

                _context15.next = 5;
                return this.getAuthProviders();

              case 5:
                _context15.t0 = _context15.sent.find(function (item) {
                  return item.name === req.provider;
                });
                _context15.next = 9;
                break;

              case 8:
                _context15.t0 = undefined;

              case 9:
                authProvider = _context15.t0;

                // Метод setNotYourComputer есть только в том случае, если приложение поддерживает
                // опцию notYourComputer
                if (this.setNotYourComputer && req.notYourComputer) {
                  actualRequest.tokenTotalExpiration = (_b = authProvider === null || authProvider === void 0 ? void 0 : authProvider.expirations) === null || _b === void 0 ? void 0 : _b.tokenValidExpiration;
                }

                if (!req.noHash && authProvider && actualRequest.password) {
                  actualRequest.password = hashWith(actualRequest.password, authProvider.hashType);
                }

                _context15.prev = 12;
                _context15.next = 15;
                return this.authService.authorize(actualRequest);

              case 15:
                response = _context15.sent;
                _context15.next = 22;
                break;

              case 18:
                _context15.prev = 18;
                _context15.t1 = _context15["catch"](12);
                this.onLoginError(createServiceError(_context15.t1));
                throw _context15.t1;

              case 22:
                _context15.next = 24;
                return this.handleChangeToken(response, req.provider);

              case 24:
                return _context15.abrupt("return", response);

              case 25:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[12, 18]]);
      }));
    }
  }, {
    key: "confirm",
    value: function confirm(code) {
      try {
        return this.authService.confirmAuthorize(code);
      } catch (error) {
        this.onLoginError(createServiceError(error));
        throw error;
      }
    }
  }, {
    key: "oAuth",
    value: function oAuth(source, provider) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this3 = this;

        var redirectUri, _yield$oAuthPopup, success, ott, res;

        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                redirectUri = getIframeSource(this.env, this.variant);
                _context16.next = 3;
                return oAuthPopup(function () {
                  return _this3.authClientService.oAuthLogin(provider, source, redirectUri);
                }, redirectUri);

              case 3:
                _yield$oAuthPopup = _context16.sent;
                success = _yield$oAuthPopup.success;
                ott = _yield$oAuthPopup.ott;

                if (!ott) {
                  _context16.next = 14;
                  break;
                }

                _context16.next = 9;
                return this.authService.exchangeOneTimeToken(ott);

              case 9:
                res = _context16.sent;

                if (!success) {
                  _context16.next = 13;
                  break;
                }

                _context16.next = 13;
                return this.handleChangeToken(res, provider);

              case 13:
                return _context16.abrupt("return", {
                  success: success,
                  ott: ott,
                  confirmation: res.confirmation
                });

              case 14:
                return _context16.abrupt("return", {
                  success: success,
                  ott: ott
                });

              case 15:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "oAuthConnect",
    value: function oAuthConnect(source) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this4 = this;

        var redirectUri;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                redirectUri = getIframeSource(this.env, this.variant);
                _context17.next = 3;
                return oAuthPopup(function () {
                  return _this4.authClientService.oAuthConnect(source, redirectUri);
                }, redirectUri);

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }]);

  return AuthProcessor;
}();

export { AuthProcessor as default };